import {AuthGuard} from '../../shared/services';
import { PartenairesDetailsRoutes } from './partenaires-details/partenaires-details.routes';
import {PartenairesListComponent} from './partenaires-list/partenaires-list.component';
import {PartenairesListRoutes} from './partenaires-list/partenaires-list.routes';
import {PartenairesComponent} from './partenaires.component';
import {Route} from '@angular/router';

export const PartenairesRoutes: Route[] = [
  {
    path: 'partenaires',
    component: PartenairesComponent,
    canActivate: [AuthGuard],
    children: [
      ...PartenairesListRoutes,
      ...PartenairesDetailsRoutes
    ]
  }
];
